import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface DocumentLibraryShellProps {
  children: ReactNode;
}

export default function DocumentLibraryShell({ children }: DocumentLibraryShellProps) {
  return (
    <Box className="card custom-card">
      <Box className="card-header p-2">
        <Typography variant="h2">Document Library</Typography>
      </Box>
      <Box className="p-3">{children}</Box>
    </Box>
  );
}
